var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 6.66699C9.16663 6.20699 9.53996 5.83366 9.99996 5.83366C10.46 5.83366 10.8333 6.20699 10.8333 6.66699V10.8337C10.8333 11.2937 10.46 11.667 9.99996 11.667C9.53996 11.667 9.16663 11.2937 9.16663 10.8337V6.66699ZM9.16663 13.3337C9.16663 12.8737 9.53996 12.5003 9.99996 12.5003C10.46 12.5003 10.8333 12.8737 10.8333 13.3337C10.8333 13.7937 10.46 14.167 9.99996 14.167C9.53996 14.167 9.16663 13.7937 9.16663 13.3337ZM9.99996 16.667C6.32413 16.667 3.33329 13.6762 3.33329 10.0003C3.33329 6.32449 6.32413 3.33366 9.99996 3.33366C13.6758 3.33366 16.6666 6.32449 16.6666 10.0003C16.6666 13.6762 13.6758 16.667 9.99996 16.667ZM9.99996 1.66699C5.39746 1.66699 1.66663 5.39783 1.66663 10.0003C1.66663 14.6028 5.39746 18.3337 9.99996 18.3337C14.6025 18.3337 18.3333 14.6028 18.3333 10.0003C18.3333 5.39783 14.6025 1.66699 9.99996 1.66699Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_733_645",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 6.66699C9.16663 6.20699 9.53996 5.83366 9.99996 5.83366C10.46 5.83366 10.8333 6.20699 10.8333 6.66699V10.8337C10.8333 11.2937 10.46 11.667 9.99996 11.667C9.53996 11.667 9.16663 11.2937 9.16663 10.8337V6.66699ZM9.16663 13.3337C9.16663 12.8737 9.53996 12.5003 9.99996 12.5003C10.46 12.5003 10.8333 12.8737 10.8333 13.3337C10.8333 13.7937 10.46 14.167 9.99996 14.167C9.53996 14.167 9.16663 13.7937 9.16663 13.3337ZM9.99996 16.667C6.32413 16.667 3.33329 13.6762 3.33329 10.0003C3.33329 6.32449 6.32413 3.33366 9.99996 3.33366C13.6758 3.33366 16.6666 6.32449 16.6666 10.0003C16.6666 13.6762 13.6758 16.667 9.99996 16.667ZM9.99996 1.66699C5.39746 1.66699 1.66663 5.39783 1.66663 10.0003C1.66663 14.6028 5.39746 18.3337 9.99996 18.3337C14.6025 18.3337 18.3333 14.6028 18.3333 10.0003C18.3333 5.39783 14.6025 1.66699 9.99996 1.66699Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_733_645)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.a299b8db2639af38298a962698745e48.svg";
export { ForwardRef as ReactComponent };